// extracted by mini-css-extract-plugin
module.exports = {"guide-wrapper":"style_guide-wrapper__FAg_h","area-guide":"style_area-guide__mVTaX","area-blurb":"style_area-blurb__aaspa","area-blurb-heading":"style_area-blurb-heading__tXNRs"};